var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"h6"},[_vm._v(" Title ")]),_c('hr'),_c('div',{staticClass:"h6"},[_vm._v(" Description ")]),_c('hr'),_c('div',{staticClass:"h6"},[_vm._v(" Date ")]),_c('hr'),_c('div',{staticClass:"h6"},[_vm._v(" Button ")])])
}]

export { render, staticRenderFns }